import React, { PureComponent } from 'react';
import CreditCardForm_BlueSwipe from './creditCardForm_blueSwipe'

class CreditCardForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth
    }
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {
    let { onSubmit, onBack, initialValues, errorMessage, isMandatory } = this.props;
    let { width } = this.state;
    let isMobile = width <= 850;
    return (
      <CreditCardForm_BlueSwipe
        initialValues={initialValues}
        handleSubmit={onSubmit}
        handleBack={onBack}
        errorMessage={errorMessage}
        isMobile={isMobile}
        isMandatory={isMandatory}
      />
    )
  }
}

export default CreditCardForm;
